import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";

const TIMEZONE = "America/Asuncion";
const DUE_DAY = parseInt(process.env.REACT_APP_PAYMENT_DUE_DAY || "7", 10);
const WARNING_WINDOW_DAYS = 7;

// Extrae año/mes/día actuales en horario paraguayo, sin importar la TZ del servidor/navegador.
function getAsuncionDateParts(date) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return {
    year: parseInt(map.year, 10),
    month: parseInt(map.month, 10), // 1-12
    day: parseInt(map.day, 10),
  };
}

function computeDueInfo(now = new Date()) {
  const { year, month, day } = getAsuncionDateParts(now);

  // Próxima fecha de pago: este mes si aún no pasó, si no el mes siguiente.
  let dueYear = year;
  let dueMonth = month;
  if (day > DUE_DAY) {
    dueMonth += 1;
    if (dueMonth > 12) {
      dueMonth = 1;
      dueYear += 1;
    }
  }

  const todayUTC = Date.UTC(year, month - 1, day);
  const dueUTC = Date.UTC(dueYear, dueMonth - 1, DUE_DAY);
  const daysRemaining = Math.round((dueUTC - todayUTC) / 86400000);

  const monthName = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(
    new Date(Date.UTC(dueYear, dueMonth - 1, 1))
  );

  return { daysRemaining, monthName };
}

export default function PaymentDueBanner() {
  const [info, setInfo] = useState(() => computeDueInfo());

  useEffect(() => {
    const interval = setInterval(() => setInfo(computeDueInfo()), 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (info.daysRemaining < 0 || info.daysRemaining > WARNING_WINDOW_DAYS) {
    return null;
  }

  const dueDayLabel = String(DUE_DAY).padStart(2, "0");

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-warning/10 border-b border-warning/30 text-warning shrink-0">
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <p className="text-sm">
        Se acerca la fecha de pago el día {dueDayLabel} de {info.monthName} de la
        cuota del plan de software. Para continuar con el servicio favor
        contactar con el administrador para el pago.
      </p>
    </div>
  );
}
